<script>
import CalendarMenuTab from '@/system/components/menu/CalendarMenuTab.vue';
import ClientsMenuTab from '@/system/components/menu/ClientsMenuTab.vue';
import Apps from '@/core/Apps'
import InvoicesMenuTab from '@/system/components/menu/InvoicesMenuTab.vue';
import ReportsMenuTab from '@/system/components/menu/ReportsMenuTab.vue';

export default {
    components: {
        CalendarMenuTab,
        ClientsMenuTab,
        InvoicesMenuTab,
        ReportsMenuTab,
    },
    props: {
        menuActive: {
            type: String,
            default: '',
        },
        hasViewedMultipleBookings: {
            required: true,
            type: Boolean
        },
        hasViewedMultipleClients: {
            required: true,
            type: Boolean
        },
        hasViewedMultipleInvoices: {
            required: true,
            type: Boolean
        },
        isTenant: {
            required: true,
            type: Boolean
        },
        showNewAppsAlert: {
            required: true,
            type: Boolean
        },
        isLocal: {
            required: true,
            type: Boolean
        },
        isTreatmentsModuleEnabled: {
            default: false,
            type: Boolean
        },
        isClientsOverviewEnabled: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            navItems: [
                {
                    id: 'calendar',
                    className: 'navigation-calendar',
                    icon: 'interface-calendar',
                    label: 'global.calendar',
                    href: '/app/calendar',
                    condition: () => this.canSeeCalendars,
                    isActive: () => this.menuActive === 'calendar',
                    hasSubmenu: this.hasViewedMultipleBookings,
                    isSubmenuOpen: false,
                    submenuComponent: 'calendar-menu-tab',
                },
                {
                    id: 'clients',
                    className: 'navigation-clients',
                    icon: 'user-multiple',
                    label: 'global.clients',
                    href: this.isClientsOverviewEnabled ? '/app/clients/overview' : '/app/clients',
                    condition: () => this.canSeeClients,
                    isActive: () => this.menuActive === 'clients',
                    hasSubmenu: this.hasViewedMultipleClients,
                    isSubmenuOpen: false,
                    submenuComponent: 'clients-menu-tab',
                },
                {
                    id: 'medcom',
                    className: 'navigation-medcom',
                    icon: 'interface-folder',
                    label: 'apps.medcom.documents',
                    href: '/app/medcom/documents',
                    condition: () => this.isMedcomActive && this.canSeeMedCom,
                    isActive: () => this.menuActive === 'medcom',
                },
                {
                    id: 'helfo-settlements',
                    className: 'navigation-helfo-settlements',
                    icon: 'file-multiple',
                    label: 'apps.helfo_settlements.name',
                    href: '/app/helfo/settlements/overview',
                    condition: () => this.isHelfoSettlementsActive && this.canSeeClients,
                    isActive: () => this.menuActive === 'helfo-settlements-overview',
                },
                {
                    id: 'products',
                    className: 'navigation-products',
                    icon: 'file-treatment-plan',
                    label: 'global.products',
                    href: '/app/products',
                    condition: () => this.canSeeProducts,
                    isActive: () => this.menuActive === 'products',
                },
                {
                    id: 'sales-products',
                    className: 'navigation-sales-products',
                    icon: 'fa-regular fa-scale-unbalanced',
                    label: 'apps.sales.name',
                    href: '/app/sales',
                    condition: () => this.canSeeSalesProducts && this.isSalesActive,
                    isActive: () => this.menuActive === 'sales-products',
                },
                {
                    id: 'invoices',
                    className: 'navigation-invoices',
                    icon: 'file-invoice',
                    label: 'global.invoices',
                    href: '/app/invoices',
                    condition: () => this.canSeeInvoices,
                    isActive: () => this.menuActive === 'invoices',
                    hasSubmenu: this.hasViewedMultipleInvoices,
                    isSubmenuOpen: false,
                    submenuComponent: 'invoices-menu-tab',
                },
                {
                    id: 'giftcards',
                    className: 'navigation-giftcards',
                    icon: 'fa-regular fa-gift-card',
                    label: 'giftcards.title_plural',
                    href: '/app/giftcards',
                    condition: () => this.canSeeGiftcards && this.isGiftcardsActive,
                    isActive: () => this.menuActive === 'giftcards',
                },
                {
                    id: 'online-courses',
                    className: 'navigation-online-courses',
                    icon: 'interface-whiteboard',
                    label: 'apps.online_courses.name',
                    href: '/app/online-courses',
                    condition: () => this.canSeeOnlineCourses && this.isOnlineCoursesActive,
                    isActive: () => this.menuActive === 'onlinecourses',
                },
                {
                    id: 'helsenett',
                    className: 'navigation-helsenett',
                    icon: 'interface-email',
                    label: 'apps.helsenett.name',
                    href: '/app/helsenett/edi',
                    condition: () => this.isHelsenettActive && this.canSeeHelsenett,
                    isActive: () => this.menuActive === 'helsenett',
                },
                {
                    id: 'statistics',
                    className: 'navigation-statistics',
                    icon: 'graph-line',
                    label: 'statistics.title',
                    href: '/app/statistics',
                    condition: () => this.canSeeStatistics,
                    isActive: () => this.menuActive === 'statistics',
                },
                {
                    id: 'statistics',
                    className: 'navigation-statistics',
                    icon: 'graph-line',
                    label: 'statistics.title',
                    href: '/app/statistics/tenancy',
                    condition: () => !this.canSeeStatistics && this.isTenant,
                    isActive: () => this.menuActive === 'statistics',
                },
                {
                    id: 'reports',
                    className: 'navigation-reports',
                    icon: 'fa-duotone fa-folders',
                    label: 'reports.title',
                    href: '/app/reports/asa-4313',
                    condition: () => this.canSeeReports,
                    isActive: () => this.menuActive === 'reports',
                    hasSubmenu: true,
                    isSubmenuOpen: false,
                    submenuComponent: 'reports-menu-tab',
                },
                {
                    id: 'easypay',
                    className: 'navigation-easy-pay',
                    icon: 'generic-credit-card',
                    label: 'online_payment.online_payment',
                    href: '/app/easypay',
                    condition: () => this.canSeeOnlinePayments && this.isOnlinePaymentActive,
                    isActive: () => this.menuActive === 'easypay',
                },
                {
                    id: 'treatments',
                    className: 'navigation-treatments',
                    icon: 'medical-bandage',
                    label: 'apps.treatments.name',
                    href: '/app/treatments',
                    condition: () => this.canSeeTreatments,
                    isActive: () => this.menuActive === 'treatments',
                },
                {
                    id: 'settings',
                    className: 'navigation-settings',
                    icon: 'navigation-settings',
                    label: 'global.settings',
                    href: '/app/settings',
                    condition: () => true,
                    isActive: () => this.menuActive === 'settings',
                },
                {
                    id: 'apps',
                    className: 'navigation-apps',
                    icon: 'navigation-catalog',
                    label: 'settings.apps',
                    href: '/app/settings/apps',
                    condition: () => this.canEditApps,
                    isActive: () => this.menuActive === 'apps',
                    showAlert: this.showNewAppsAlert,
                },
                {
                    id: 'accounts',
                    className: 'navigation-accounts',
                    icon: 'navigation-finances',
                    label: 'Accounting',
                    href: '/app/accounting',
                    condition: () => this.isLocal,
                    isActive: () => this.menuActive === 'accounts',
                },
            ],
        }
    },
    methods: {
        openSubmenu(tab) {
            // first close all other tab submenus
            this.navItems.forEach(item => {
                if (item.hasSubmenu && item.id !== tab.id) {
                    item.isSubmenuOpen = false;
                }
            });

            tab.isSubmenuOpen = !tab.isSubmenuOpen;
        },
    },
    computed: {
        canSeeCalendars() {
            return this.$can('see-calendars');
        },

        canSeeClients() {
            return this.$canEither('see-clients', 'see-clientsassigned');
        },

        isMedcomActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Medcom);
        },

        canSeeMedCom() {
            return this.$canEither('see-medcom', 'see-medcomassigned');
        },

        isHelfoSettlementsActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.HelfoSettlements);
        },

        canSeeProducts() {
            return this.$can('see-products');
        },

        canSeeSalesProducts() {
            return this.$can('see-salesproducts');
        },

        isSalesActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Sales);
        },

        canSeeInvoices() {
            return this.$canEither('see-invoices', 'see-invoicesassigned');
        },

        canSeeGiftcards() {
            return this.$can('see-giftcards');
        },

        canSeeReports() {
            // show the Reports based on Helfo Settlements
            return this.isHelfoSettlementsActive && this.canSeeClients
        },

        isGiftcardsActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Giftcards);
        },

        canSeeOnlineCourses() {
            return this.$can('see-onlinecourses');
        },

        isOnlineCoursesActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.OnlineCourses);
        },

        canSeeHelsenett() {
            return this.$can('see-helsenettmessaging');
        },

        isHelsenettActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Helsenett);
        },

        canSeeStatistics() {
            return this.$can('see-statistics');
        },

        canSeeOnlinePayments() {
            return this.$canEither('see-onlinepayment', 'see-onlinepaymentassigned');
        },

        canSeeTreatments() {
            return this.isTreatmentsModuleEnabled
                && this.$store.getters['apps/isAppEnabled'](Apps.Treatments)
                && this.$canEither('see-clients', 'see-clientsassigned');
        },

        isOnlinePaymentActive() {
            return this.$store.getters['apps/isAppEnabled'](Apps.EasyPay);
        },

        canEditApps() {
            return this.$can('edit-apps');
        },

        availableTabs() {
            return this.navItems.filter(tab => tab.condition());
        },
    },
}
</script>

<template>
    <nord-nav-group>
        <template v-for="(tab, index) in availableTabs" :key="tab.id">
            <nord-nav-item
                :class="[
                    tab.className,
                    {
                        'has-submenu': tab.hasSubmenu
                    }
                ]"
                :active="tab.isActive()"
                :icon="tab.icon.startsWith('fa') ? '' : tab.icon"
            >
                <!-- Fix to enable users opening a page in new tab -->
                <a :href="tab.href" class="link-overlay"></a>
                <nord-stack direction="horizontal" justify-content="space-between" align-items="center">
                    <i v-if="tab.icon.startsWith('fa')" :class="tab.icon"></i>
                    <nord-stack direction="horizontal" align-items="center">
                        {{ trans(tab.label) }}
                        <template v-if="tab.showAlert">
                            <span class="new-apps-message-alert"></span>
                        </template>
                    </nord-stack>

                    <nord-icon
                        v-if="tab.hasSubmenu"
                        name="arrow-expand-right-small"
                        :class="[
                            'nav-item-submenu-icon n-margin-ie-xs',
                            {
                                'open': tab.isSubmenuOpen
                            }
                        ]"
                        @click.stop="openSubmenu(tab)">
                    </nord-icon>
                </nord-stack>
            </nord-nav-item>
            <component v-if="tab.hasSubmenu" :is="tab.submenuComponent" :open="tab.isSubmenuOpen"></component>
        </template>
    </nord-nav-group>
</template>

<style lang="scss" scoped>
.new-apps-message-alert {
    background-color: #ff5b5b;
    color: white;
    width: 8px;
    height: 8px;
    text-align: center;
    display: block;
    border-radius: 100%;
    font-size: 10.2px;
}

.nav-item-submenu-icon {
    width: 10px;
    padding-top: 4px;
    transition: all .2s;
    z-index: 10;

    &.open {
        transform: rotate(90deg);
    }
}

.link-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
